import { css, cx } from '@emotion/css'
import {
  spacing,
  fontWeight,
  buttonVariant,
  buttonSize as getButtonSize,
  borderRadius,
  colors,
  breakpoint,
  mediaQueryHelper,
  fontSize,
} from '@offerzen/pinata'

const buttonSize = getButtonSize('default')

const styles = {
  container: css({
    marginLeft: spacing.small,
  }),

  successNotification: cx(
    buttonSize,
    css({
      display: 'flex',
      alignItems: 'center',
      padding: 0,

      p: {
        margin: 0,
        marginLeft: spacing.small,
      },

      [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
        height: 'auto',
      },
    }),
  ),

  fieldset: css({
    border: 'none',
    padding: 0,

    [mediaQueryHelper(breakpoint.desktop)]: {
      width: breakpoint.desktop,
    },
  }),

  legendGroup: css({
    display: 'flex',
    alignItems: 'center',
    gap: spacing.default,
    color: colors.oxfordBlue,

    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      flexDirection: 'column',
    },
  }),

  radioGroup: css({
    [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
      width: '100%',
    },
  }),

  label: css({
    fontWeight: fontWeight.semiBold,
    margin: 0,
  }),

  radioOption: cx(
    css({
      borderRadius: borderRadius.default,
      border: '1px solid transparent',
      fontSize: fontSize.default,

      input: {
        border: 'none',
      },

      'input:checked + span': {
        color: colors.white,
      },
    }),
    buttonVariant('outlined', 'dark'),
    buttonSize,
  ),
}

export default styles
